import React from 'react';
import { createPortal } from 'react-dom';
import { ArrowsPointingOutIcon } from '@heroicons/react/24/outline';

export default function ResizeHandle({ onMouseDown, usePortal = false, containerRef, position, size }) {
  if (usePortal && typeof document !== 'undefined' && containerRef?.current && position && size) {
    const rect = containerRef.current.getBoundingClientRect();
    const HANDLE = 32; // w-8/h-8 ~ 32px
    const left = rect.left + (position.x || 0) + (size.width || 0) - HANDLE / 2;
    const top = rect.top + (position.y || 0) + (size.height || 0) - HANDLE / 2;

    return createPortal(
      <div
        className="w-8 h-8 cursor-se-resize bg-white border-2 border-indigo-500 rounded-br hover:bg-gray-50 sbw-resize-handle flex items-center justify-center"
        data-role="resize-handle"
        onPointerDown={(e) => { e.preventDefault(); e.stopPropagation(); onMouseDown?.(e); }}
        onMouseDown={(e) => { e.stopPropagation(); onMouseDown?.(e); }}
        style={{ position: 'fixed', left, top, zIndex: 100000, pointerEvents: 'auto' }}
        title="Resize"
      >
        <ArrowsPointingOutIcon className="w-5 h-5 text-indigo-600" />
      </div>,
      document.body
    );
  }

  return (
    <div
      className="absolute -bottom-1 -right-1 w-8 h-8 cursor-se-resize bg-white border-2 border-indigo-500 rounded-br hover:bg-gray-50 sbw-resize-handle flex items-center justify-center"
      data-role="resize-handle"
      onPointerDown={(e) => { 
        e.stopPropagation(); 
        onMouseDown?.(e); 
      }}
      onMouseDown={(e) => { 
        e.stopPropagation(); 
        onMouseDown?.(e); 
      }}
      style={{ zIndex: 1000, pointerEvents: 'auto' }}
      title="Resize"
    >
      <ArrowsPointingOutIcon className="w-5 h-5 text-indigo-600" />
    </div>
  );
}
